import React, { useEffect, useState } from "react";
import { Divider, Form, Table } from "antd";
import { DataExporterFilters } from "./DataExporterFilters/DataExporterFilters";
import {
  checkIsLoading,
  getDictionaryItemById,
  toDisplayFormat,
  toDisplayFormatWithTime,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils";
import { useAppDispatch, useAppSelector } from "../..";
import "./DataExporter.less";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import { TableColumn } from "../../lib/interfaces";
import { getGlsTasks } from "../../store/slices/glsTasks";
import { GlsTask } from "../../lib/interfaces/GlsTask";

const columnsWidths = {
  id: "75px",
  createDate: "130px",
  periodFrom: "100px",
};

const DataExporter = () => {
  const dispatch = useAppDispatch();

  const { glsTasks, glsTasksLoading } = useAppSelector((state) => state.glsTasks);
  const { glsStatuses, glsTypes } = useAppSelector((state) => state.rtkDictionaries);

  const [form] = Form.useForm();

  const [filtersCollapseState, setFiltersCollapseState] = useState("unfolded");
  const [tableData, setTableData] = useState<GlsTask[]>([]);

  useEffect(() => {
    setTableData(glsTasks?.map((item) => ({ ...item })));
  }, [glsTasks]);

  const resetSearch = () => {
    form.resetFields();
  };

  const onSearch = (values) => {
    const params = {
      glsTypeIds: values?.glsTypeIds,
      glsStatusIds: values?.glsStatusIds,
      onDate: values?.onDate ? toHttpFormatStartOfDay(values.onDate) : undefined,
      periodFrom: values?.period?.[0] ? toHttpFormatStartOfDay(values.period[0]) : undefined,
      periodTo: values?.period?.[1] ? toHttpFormatEndOfDay(values.period[1]) : undefined,
      ids: values?.ids,
    };
    dispatch(getGlsTasks(params));
  };

  const getColumns = (): TableColumn[] => [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      hidden: true,
      width: columnsWidths.id,
      render: (id) => (
        <span style={{ color: "rgba(0, 0, 0, 0.3)", fontWeight: "normal" }}>{id}</span>
      ),
    },
    {
      title: "Дата создания",
      dataIndex: "createDate",
      key: "createDate",
      hidden: false,
      width: columnsWidths.createDate,
      render: (createDate) => (createDate ? toDisplayFormatWithTime(createDate) : ""),
    },
    {
      title: "Период",
      dataIndex: "periodFrom",
      key: "periodFrom",
      hidden: false,
      width: columnsWidths.periodFrom,
      render: (_, { periodFrom, periodTo }) =>
        periodFrom && periodTo
          ? `${toDisplayFormat(periodFrom)} - ${toDisplayFormat(periodTo)}`
          : "",
    },
    {
      title: "Тип",
      dataIndex: "glsTypeId",
      key: "glsTypeId",
      hidden: false,
      width: columnsWidths.id,
      render: (glsTypeId) => getDictionaryItemById(glsTypes, glsTypeId)?.name,
    },
    {
      title: "Статус",
      dataIndex: "glsStatusId",
      key: "glsStatusId",
      hidden: false,
      width: columnsWidths.id,
      render: (glsStatusId) => getDictionaryItemById(glsStatuses, glsStatusId)?.name,
    },
    {
      title: "ID задания",
      dataIndex: "taskId",
      key: "taskId",
      hidden: true,
      width: columnsWidths.id,
    },
    {
      title: "Комментарий",
      dataIndex: "dsc",
      key: "dsc",
      hidden: true,
      width: columnsWidths.id,
    },
  ];

  const [columns, setColumns] = useState<TableColumn[]>(getColumns());

  useEffect(() => {
    setColumns(getColumns());
  }, [glsTypes, glsStatuses]);

  return (
    <>
      <DataExporterFilters
        form={form}
        filtersCollapseState={filtersCollapseState}
        setFiltersCollapsState={setFiltersCollapseState}
        onSearch={onSearch}
        resetSearch={resetSearch}
        defaultServicesSearchParams={{ glsStatusIds: [2, 3] }}
      />
      <Divider style={{ margin: "0" }} />
      <div style={{ marginLeft: "97%", marginTop: "7px" }}>
        <ToggleColumns columns={columns} setColumns={setColumns} tableName="dataExporter" />
      </div>
      <Table
        size="small"
        className="table_no-hover"
        columns={[...columns].filter((item) => !item.hidden)}
        dataSource={tableData}
        loading={checkIsLoading(glsTasksLoading)}
        pagination={false}
        scroll={{ y: 400, x: 1200 }}
        rowClassName={({ sequenceNumber }) => (sequenceNumber % 2 ? "data-exporter__oddRow" : "")}
      />
    </>
  );
};

export default DataExporter;
